import HeaderComponent from '@arco-design/web-react/es/Layout/header'
import React, { useEffect, useState } from 'react';
import Logo from "../../assets/images/pixl_logo_black 1.png";
import Dropdown from 'react-bootstrap/Dropdown';
import { useLocation, useNavigate } from 'react-router-dom';
import { combineAllRoutes, filterRouteData, getLocalStorage, userValidation } from '../../Functions/Utils';
import { routeList } from '../../globalData/constant';
import { Alert } from 'react-bootstrap';
import AlertBox from '../../Components/AlertBox/AlertBox';
import InputComponent2 from '../../Components/InputComponent/InputComponent2';
import PopupModal from '../../Components/ModalComponent/PopupModal';
import { useStoreValues } from '../../Context/storeProvider';
import { ManageApis } from '../../AppServices/ManageApi';

export default function Landingpage() {
    const { user } = useStoreValues();

    const [toggled, setToggled] = useState(false);
    const [showAvatar_Popup, setShowAvatar_Popup] = useState(false);
    const [errors, setErrors] = useState({});
    const [assigned, setAssigned] = useState({
        masking: false,
        reader: false,
        ovd: false,
        verification: false,
        chatbot: false,
    })

    const [changePasswordData, setChangePasswordData] = useState({
        current_password: "",
        new_password: "",
        confirm_password: "",

    });
    let chnagepasswordForm = [

        {
            type: "password",
            name: "current_password",
            label: "Current Password",
            isDisabled: false,
            error: "",
            value: changePasswordData.current_password,
        },
        {
            type: "password",
            name: "new_password",
            label: "New Password",
            isDisabled: false,
            error: "",
            value: changePasswordData.new_password,
        },
        {
            type: "password",
            name: "confirm_password",
            label: "Confirm Password",
            isDisabled: false,
            error: "",
            value: changePasswordData.confirm_password,
        },
    ];
    const AlertinitialValue = {
        show: false,
        message: "",
        isfalse: false,
        isSuccess: false,
        isWarning: false,
    };
    const location = useLocation();
    const [showAlert, setShowAlert] = useState(AlertinitialValue);
    const formatingMenuList = location.state?.formatingMenuList;
    //console.log("Menu is here ======>", formatingMenuList)
    let
        readerRoute = {
            "Document Masking": routeList['Document Masking']
        },
        maskingRoute = {
            "Document Reader": routeList['Document Reader']
        },
        verificationRoute = {
            "Document Verification": routeList['Document Verification']
        }
        ,
        ovdRoute = {
            "OVD Classification": routeList['OVD Classification']
        },
        hitoVerview = {
            "API Hit": routeList['API Hit']
        },
        apihits = {
            "API Logs": routeList['API Logs']
        },
        resumeRoute = {
            "Resume Parser": routeList['Resume Parser']
        },
        chatbotRoute = {
            "AI Chatbot": routeList['AI Chatbot']
        }


    const navigate = useNavigate()
    const [isLoading, setisLoading] = useState(false);

    const [visible, setvisible] = useState({ show: false, type: "" });
    const handleLogout = () => {

        setisLoading(true)
        localStorage.clear()
        window.location.href = '/'
    }
    const handleChangePassword = async () => {

        const validate = () => {
            let isValid = true;

            let array = Object.keys(changePasswordData);
            let result = userValidation(changePasswordData, array);

            result.forEach((item) => {

                handleError(`Please fill the ${item.replace("_", " ")}`, item);
                isValid = false;

            });

            array.forEach((element) => {
                if (changePasswordData[element].length < 5) {

                    handleError(`Please enter a password with a minimum of 5 characters`, element);
                    isValid = false;
                } else {
                    handleError(null, element);
                    isValid = true;
                }

            });

            // //console.log(result);

            Object.keys(errors).forEach((key) => {
                if (errors[key]) {
                    isValid = false;
                    // //console.log(errors[key]);
                }
            });

            return isValid;
        };
        try {
            if (validate()) {
                setisLoading(true);
                setvisible((pre) => ({
                    show: false,
                    type: "",
                }));
                const reqstBody = {
                    id: getLocalStorage("clientId"),
                    emailId: getLocalStorage("email"),
                    currentPassword: changePasswordData.current_password,
                    newPassword: changePasswordData.new_password,
                    confirmNewPassword: changePasswordData.confirm_password,
                };
                let result = await ManageApis(
                    "post",
                    global.changePassword,
                    reqstBody
                );
                if (result.message === "Success") {
                    // //console.log(result);
                    if (result?.response_data == "Password changed successfully.") {
                        setChangePasswordData((pre) => ({

                            confirm_password: "",
                            current_password: "",
                            new_password: "",
                        }));
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: result.response_data,
                            isSuccess: true,
                        }));
                        setisLoading(false);
                    }
                    else {
                        setChangePasswordData((pre) => ({

                            confirm_password: "",
                            current_password: "",
                            new_password: "",
                        }));
                        setShowAlert((pre) => ({
                            ...pre,
                            show: true,
                            message: result.response_data,
                            isSuccess: false,
                            isWarning: true,
                        }));
                        setisLoading(false);
                    }
                    // alert("Password changed successfully.");
                } else {
                    setChangePasswordData((pre) => ({

                        confirm_password: "",
                        current_password: "",
                        new_password: "",
                    }));
                    setisLoading(false);
                    // //console.log(result);
                    setvisible((pre) => ({
                        show: false,
                        type: "",
                    }));
                    setShowAlert((pre) => ({
                        ...pre,
                        show: true,
                        message: result?.response_data?.title,
                        isSuccess: false,
                        isfalse: true,
                    }));
                }
            }

        } catch (err) {
            // //console.log(err);
        }
    }
    const handleChange = (e, type) => {
        const { name, value } = e.target;
        // //console.log(name, value, type);

        // ""
        switch (name) {
            case "current_password":
                // ""
                setChangePasswordData((prevState) => ({
                    ...prevState,
                    [name]: value.slice(0, 15).replace(" ", "").trim(),
                })); //maxlength 12
                if (!value) {
                    handleError("Please enter current password", name);
                }
                if (
                    changePasswordData.new_password &&
                    value === changePasswordData.new_password
                ) {
                    handleError("current password can't be same as new password", name);
                } else {
                    handleError(null, name);

                    handleError(null, "new_password");
                }



                break;
            case "new_password":
                // ""
                setChangePasswordData((prevState) => ({
                    ...prevState,
                    new_password: value.slice(0, 15).replace(" ", "").trim(),
                })); //maxlength 12
                if (
                    changePasswordData.confirm_password &&
                    value !== changePasswordData.confirm_password
                ) {
                    handleError("Passwords do not match", name);
                }
                else if (
                    changePasswordData.current_password &&
                    value === changePasswordData.current_password
                ) {
                    handleError("new password can't be same as current password", name);
                }
                else {
                    handleError(null, name);
                    handleError(null, "confirm_password");
                    handleError(null, "current_password");
                }

                break;
            case "confirm_password":
                setChangePasswordData((prevState) => ({
                    ...prevState,
                    [name]: value.slice(0, 15).replace(" ", "").trim(),
                })); //maxlength 12
                if (
                    changePasswordData.new_password &&
                    changePasswordData.new_password !== value
                ) {
                    handleError("Passwords do not match", name);
                } else {
                    handleError(null, name);
                    handleError(null, "new_password");
                }

                break;


            default:
                break;
        }

    };
    const handleError = (error, input) => {
        setErrors((prevState) => ({ ...prevState, [input]: error }));
    };

    useEffect(() => {
        const val = filterRouteData(maskingRoute, [...formatingMenuList, { menuName: "landing" }, { menuName: "DashBoard" }, { menuName: "api-logs" },{ menuName: "service-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }].map((itm) => itm.menuName))
        if (Object.values(val)[0].length > 0) {
            setAssigned((prevState) => ({
                ...prevState,
                reader: true,
            }));
        }
        const valverif = filterRouteData(verificationRoute, [...formatingMenuList, { menuName: "landing" }, { menuName: "DashBoard" }, { menuName: "api-logs" },{ menuName: "service-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }].map((itm) => itm.menuName))
        if (Object.values(valverif)[0].length > 0) {
            setAssigned((prevState) => ({
                ...prevState,
                verification: true,
            }));
        }
        const valmasking = filterRouteData(readerRoute, [...formatingMenuList, { menuName: "landing" }, { menuName: "DashBoard" }, { menuName: "api-logs" },{ menuName: "service-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }].map((itm) => itm.menuName))
        if (Object.values(valmasking)[0].length > 0) {
            setAssigned((prevState) => ({
                ...prevState,
                masking: true,
            }));
        }
        const valovd = filterRouteData(ovdRoute, [...formatingMenuList, { menuName: "landing" }, { menuName: "DashBoard" }, { menuName: "api-logs" }, { menuName: "service-logs" },{ menuName: "hitdashboard" }, { menuName: "hitoverview" }].map((itm) => itm.menuName))
        // ""
        if (Object.values(valovd)[0].length > 0) {
            setAssigned((prevState) => ({
                ...prevState,
                ovd: true,
            }));
        }
        const valChatbot = filterRouteData(chatbotRoute, [...formatingMenuList, { menuName: "landing" }, { menuName: "DashBoard" }, { menuName: "api-logs" },{ menuName: "service-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }].map((itm) => itm.menuName))
        // ""
        if (Object.values(valChatbot)[0].length > 0) {
            setAssigned((prevState) => ({
                ...prevState,
                chatbot: true,
            }));
        }
        
    }, [])

    const handleNav = (clickedRoute) => {
        // ""
        let route
        switch (clickedRoute) {
            case 'reader': route = readerRoute
                break
            case 'masking': route = maskingRoute
                break
            case 'verification': route = verificationRoute
                break
            case 'ovd': route = ovdRoute
                break
            case 'hitoVerview': route = hitoVerview
                break
            case 'apihits': route = apihits
                break
            case 'chatbot': route = chatbotRoute
                break
            // case 'resume': route = resumeRoute
            //     break
        }



        let pathname = combineAllRoutes(
            filterRouteData(route, [...formatingMenuList, { menuName: "landing" }, { menuName: "DashBoard" }, { menuName: "api-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }].map((itm) => itm.menuName))
        )[0]?.path
        if (pathname) {
            // ""
            //console.log(pathname)
            combineAllRoutes(
                filterRouteData(route, [...formatingMenuList, { menuName: "landing" }, { menuName: "DashBoard" }, { menuName: "api-logs" },{ menuName: "service-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }].map((itm) => itm.menuName))
            )[0]?.name == 'chatbot' ?
            window.open('/chatbot', '_blank'):
            navigate(
                combineAllRoutes(
                    filterRouteData(route, [...formatingMenuList, { menuName: "landing" }, { menuName: "DashBoard" }, { menuName: "api-logs" },{ menuName: "service-logs" }, { menuName: "hitdashboard" }, { menuName: "hitoverview" }].map((itm) => itm.menuName))
                )[0]?.path
            )
        }
        else {
            setShowAlert((pre) => ({
                ...pre,
                show: true,
                message: "You don't have access to these products. Please contact the support team",
                isSuccess: false,
            }));
        }
        // let path = combineAllRoutes(
        //     filterRouteData(docroute, formatingMenuList.map((itm) => itm.menuName))
        // )[0]?.path
        // alert(path)

        // navigate(
        //     formatingMenuList.length > 0
        //         ? combineAllRoutes(
        //             filterRouteData(routeList, formatingMenuList.map((itm) => itm.menuName))
        //         )[0]?.path : '/dashboard'
        // )
    }
    // alert(formatingMenuList[0].menuName)
    return (
        <>
            <AlertBox
                show={showAlert.show}
                message={showAlert.message}
                enableFailIcon={showAlert.isfalse}
                enableSuccessIcon={showAlert.isSuccess}
                enableWarningIcon={showAlert.isWarning}
                handlecancel={() => { setShowAlert(AlertinitialValue) }} />
            <div className=' bg_gray2'>
                <header className='px-3 py-3'>
                    <div className='align-items-center d-flex justify-content-between'>
                        <div>
                            <img src={Logo} className="logo" />
                        </div>
                        <div className='align-items-center d-flex'>
                            {user}
                            <div className='bg-white p-1 rounded-pill'>
                                <Dropdown>
                                    <Dropdown.Toggle variant="unset" className="">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
                                            <path d="M18 6C19.5913 6 21.1174 6.63214 22.2426 7.75736C23.3679 8.88258 24 10.4087 24 12C24 13.5913 23.3679 15.1174 22.2426 16.2426C21.1174 17.3679 19.5913 18 18 18C16.4087 18 14.8826 17.3679 13.7574 16.2426C12.6321 15.1174 12 13.5913 12 12C12 10.4087 12.6321 8.88258 13.7574 7.75736C14.8826 6.63214 16.4087 6 18 6ZM18 21C24.63 21 30 23.685 30 27V30H6V27C6 23.685 11.37 21 18 21Z" fill="#1A82E2" />
                                        </svg>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu className="NotifMenu">
                                        <div className={`zi_1  br_5 border bg-white `}>
                                            <div className="d-flex flex-column text-black">
                                                <div className="border-bottom d-flex" onClick={() => setvisible((pre) => ({ show: true }))}>
                                                    <span className="px-3 ps-2 py-3 font_14 font_500  px_hover_1 cursor-pointer w-100">Change password</span>
                                                </div>
                                                <div className="border-bottom d-flex">
                                                    <span className="px-3 ps-2 py-3 font_14 font_500 px_hover_1 cursor-pointer w-100" onClick={handleLogout}>Log out</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </header >
                <PopupModal
                    title=""
                    size="md"
                    visible={visible.show}
                    handleClose={() => {
                        setvisible((prv) => ({ show: false, type: "" })); setChangePasswordData((pre) => ({
                            confirm_password: "",
                            current_password: "",
                            new_password: "",
                        })); setErrors({})
                    }}
                >
                    <div className="row">
                        {chnagepasswordForm.map((itm, index) => (
                            <div
                                key={index}
                                className={`${itm.hasOwnProperty("col") ? itm.col : "col-12"}`}
                            >
                                <InputComponent2
                                    label={itm.label}
                                    name={itm.name}
                                    type={itm.type}
                                    value={changePasswordData[itm.name]}
                                    error={errors[itm.name]}
                                    disabled={itm.isDisabled}
                                    onchange={(e) => handleChange(e, visible.type)}
                                />
                            </div>
                        ))}

                        <div className=" d-flex justify-content-end">
                            <button
                                className="btn btn-master px-3 font_14"
                                onClick={handleChangePassword}
                            >
                                Submit
                            </button>
                        </div>
                    </div>


                </PopupModal>

                <div className='ourProduct overflow-auto scrollbar1'>
                    <div className='px-3'>
                        <h1 className='pt-0 pt-lg-3 text-center font_18 font_600 text_master2'>OUR PRODUCTS</h1>
                        <div className='row pt-4'>


                            <div className='col-12 col-md-6 col-lg-3 mb-4 mb-lg-3'>
                                <div className='cursor-pointer shadow_sm3 bg-white d-flex flex-column align-items-center px-3 py-5 br_15 h-100'
                                    onClick={() => {
                                        handleNav('hitoVerview')
                                    }}>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="73" height="70" viewBox="0 0 73 70" fill="none">
                                            <g clip-path="url(#clip0_409_423)">
                                                <path d="M46.0524 8.02509H24.7974V19.3342H46.0524V8.02509Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M22.8126 26.7357H11.7989V38.0448H22.8126V26.7357Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M59.2479 26.7357H48.0372V38.0448H59.2479V26.7357Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M23.214 32.3329H47.4387" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M6.67044 44.6419H27.0547" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M44.0906 44.5436H64.4746" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M35.6295 18.8495V32.1434" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M17.2149 38.7415V45.5364" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M7.66296 44.1577V50.9523" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M26.0779 43.8615V50.6563" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M44.7877 43.4684V50.2633" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M63.5963 43.6644V50.459" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M53.4534 38.7415V45.5364" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M7.60603 61.9741C10.8921 61.9741 13.556 59.3102 13.556 56.0241C13.556 52.738 10.8921 50.0741 7.60603 50.0741C4.31994 50.0741 1.65604 52.738 1.65604 56.0241C1.65604 59.3102 4.31994 61.9741 7.60603 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M26.3159 61.9741C29.602 61.9741 32.2659 59.3102 32.2659 56.0241C32.2659 52.738 29.602 50.0741 26.3159 50.0741C23.0298 50.0741 20.3659 52.738 20.3659 56.0241C20.3659 59.3102 23.0298 61.9741 26.3159 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M44.9277 61.9741C48.2138 61.9741 50.8777 59.3102 50.8777 56.0241C50.8777 52.738 48.2138 50.0741 44.9277 50.0741C41.6416 50.0741 38.9777 52.738 38.9777 56.0241C38.9777 59.3102 41.6416 61.9741 44.9277 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M63.5392 61.9741C66.8253 61.9741 69.4892 59.3102 69.4892 56.0241C69.4892 52.738 66.8253 50.0741 63.5392 50.0741C60.2531 50.0741 57.5892 52.738 57.5892 56.0241C57.5892 59.3102 60.2531 61.9741 63.5392 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_409_423">
                                                    <rect width="72" height="69.8182" fill="white" transform="translate(0.5 0.0909424)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <h2 className='font_16 font_400 mt-3 mb-3'>API Hit</h2>
                                    <div className='d-flex justify-content-center flex-wrap gap-1'>
                                    </div>
                                </div>
                            </div>

                            <div className='col-12 col-md-6 col-lg-3 mb-4 mb-lg-3'>
                                <div className='cursor-pointer shadow_sm3 bg-white d-flex flex-column align-items-center px-3 py-5 br_15 h-100'
                                    onClick={() => {
                                        handleNav('apihits')
                                    }}>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="73" height="70" viewBox="0 0 73 70" fill="none">
                                            <g clip-path="url(#clip0_409_423)">
                                                <path d="M46.0524 8.02509H24.7974V19.3342H46.0524V8.02509Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M22.8126 26.7357H11.7989V38.0448H22.8126V26.7357Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M59.2479 26.7357H48.0372V38.0448H59.2479V26.7357Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M23.214 32.3329H47.4387" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M6.67044 44.6419H27.0547" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M44.0906 44.5436H64.4746" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M35.6295 18.8495V32.1434" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M17.2149 38.7415V45.5364" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M7.66296 44.1577V50.9523" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M26.0779 43.8615V50.6563" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M44.7877 43.4684V50.2633" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M63.5963 43.6644V50.459" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M53.4534 38.7415V45.5364" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M7.60603 61.9741C10.8921 61.9741 13.556 59.3102 13.556 56.0241C13.556 52.738 10.8921 50.0741 7.60603 50.0741C4.31994 50.0741 1.65604 52.738 1.65604 56.0241C1.65604 59.3102 4.31994 61.9741 7.60603 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M26.3159 61.9741C29.602 61.9741 32.2659 59.3102 32.2659 56.0241C32.2659 52.738 29.602 50.0741 26.3159 50.0741C23.0298 50.0741 20.3659 52.738 20.3659 56.0241C20.3659 59.3102 23.0298 61.9741 26.3159 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M44.9277 61.9741C48.2138 61.9741 50.8777 59.3102 50.8777 56.0241C50.8777 52.738 48.2138 50.0741 44.9277 50.0741C41.6416 50.0741 38.9777 52.738 38.9777 56.0241C38.9777 59.3102 41.6416 61.9741 44.9277 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                <path d="M63.5392 61.9741C66.8253 61.9741 69.4892 59.3102 69.4892 56.0241C69.4892 52.738 66.8253 50.0741 63.5392 50.0741C60.2531 50.0741 57.5892 52.738 57.5892 56.0241C57.5892 59.3102 60.2531 61.9741 63.5392 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_409_423">
                                                    <rect width="72" height="69.8182" fill="white" transform="translate(0.5 0.0909424)" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                    </div>
                                    <h2 className='font_16 font_400 mt-3 mb-3'>API Log</h2>
                                    <div className='d-flex justify-content-center flex-wrap gap-1'>
                                    </div>
                                </div>
                            </div>
                            {assigned.reader &&
                                <div className='col-12 col-md-6 col-lg-3 mb-3'>
                                    <div className='cursor-pointer shadow_sm3 bg-white d-flex flex-column align-items-center px-3 py-5 br_15 mb-4 mb-lg-0' onClick={() => { handleNav('masking') }}>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73" fill="none">
                                                <path d="M15.494 45.5V57.5H27.494V63.5H9.49402V45.5H15.494ZM63.494 45.5V63.5H45.494V57.5H57.494V45.5H63.494ZM39.491 18.5L52.691 51.5H46.226L42.623 42.5H30.353L26.756 51.5H20.294L33.491 18.5H39.491ZM36.491 27.155L32.75 36.5H40.226L36.491 27.155ZM27.494 9.5V15.5H15.494V27.5H9.49402V9.5H27.494ZM63.494 9.5V27.5H57.494V15.5H45.494V9.5H63.494Z" fill="#1A82E2" />
                                            </svg>
                                        </div>
                                        <h2 className='font_16 font_400 mt-3 mb-3' >Document Reader</h2>
                                        <div className='d-flex justify-content-center flex-wrap gap-1'>
                                            <p className='mb-0 me-3 text_gray7'>Invoice </p>
                                            <p className='mb-0 me-3 text_gray7'>Receipt</p>
                                            <p className='mb-0 me-3 text_gray7'>Driving Licence</p>
                                            <p className='mb-0 me-3 text_gray7'>Health Insurance</p>
                                            <p className='mb-0 me-3 text_gray7'>Seaman Book</p>
                                            <p className='mb-0 me-3 text_gray7'>ID Card</p>
                                        </div>
                                    </div>
                                </div>
                            }

                            {assigned.verification &&
                                <div className='col-12 col-md-6 col-lg-3 mb-4 mb-lg-3'>
                                    <div className='cursor-pointer shadow_sm3 bg-white d-flex flex-column align-items-center px-3 py-5 br_15 h-100' onClick={() => { handleNav('verification') }}>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="73" height="65" viewBox="0 0 73 65" fill="none">
                                                <path d="M54.9001 28.0201L49.2201 22.3401L32.2601 39.3401L23.7801 30.8201L18.1001 36.5001L32.2601 50.6601L54.9001 28.0201Z" fill="#1A82E2" />
                                                <path d="M0.5 0.5V64.5H72.5V0.5H0.5ZM64.5 56.5H8.5V16.5H64.5V56.5Z" fill="#1A82E2" />
                                            </svg>
                                        </div>
                                        <h2 className='font_16 font_400 mt-3 mb-3'>Document Verification</h2>
                                        <div className='d-flex justify-content-center flex-wrap gap-1'>
                                            <p className='mb-0 me-3 text_gray7'>Pan verification </p>
                                        </div>
                                    </div>
                                </div>
                            }


                            {assigned.masking &&
                                <div className='col-12 col-md-6 col-lg-3 mb-4 mb-lg-3'>
                                    <div className='cursor-pointer shadow_sm3 bg-white d-flex flex-column align-items-center px-3 py-5 br_15 h-100' onClick={() => { handleNav('reader') }}>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="73" height="73" viewBox="0 0 73 73" fill="none">
                                                <path d="M28.5164 6.02852C34.2737 8.77064 39.1361 13.0883 42.5399 18.4809C45.9436 23.8736 47.7494 30.1205 47.7479 36.4975C47.7494 42.8745 45.9436 49.1214 42.5399 54.514C39.1361 59.9067 34.2737 64.2243 28.5164 66.9664C33.1734 68.1822 38.0471 68.3143 42.7631 67.3525C47.4792 66.3908 51.912 64.3607 55.721 61.4185C59.53 58.4762 62.6139 54.6999 64.7357 50.3797C66.8576 46.0596 67.9608 41.3106 67.9608 36.4975C67.9608 31.6844 66.8576 26.9353 64.7357 22.6152C62.6139 18.2951 59.53 14.5188 55.721 11.5765C51.912 8.63419 47.4792 6.60419 42.7631 5.64243C38.0471 4.68067 33.1734 4.81275 28.5164 6.02852ZM19.3483 4.85439C27.7411 0.304504 37.5977 -0.72498 46.7496 1.99241C55.9015 4.70981 63.5991 10.9515 68.149 19.3443C72.6989 27.7372 73.7283 37.5938 71.0109 46.7457C68.2935 55.8976 62.0519 63.5952 53.659 68.1451C45.265 72.6955 35.407 73.7251 26.2539 71.0073C17.1007 68.2895 9.40205 62.0469 4.85156 53.6528C0.301079 45.2588 -0.728504 35.4009 1.98931 26.2477C4.70713 17.0945 10.9497 9.39588 19.3438 4.84539L19.3483 4.85439Z" fill="#1A82E2" />
                                            </svg>
                                        </div>
                                        <h2 className='font_16 font_400 mt-3 mb-3'>Document Masking</h2>
                                        <div className='d-flex justify-content-center flex-wrap gap-1'>
                                            <p className='mb-0 me-3 text_gray7'>Aadhaar masking </p>
                                        </div>
                                    </div>
                                </div>
                            }
                            {assigned.ovd &&
                                <div className='col-12 col-md-6 col-lg-3 mb-4 mb-lg-3'>
                                    <div className='cursor-pointer shadow_sm3 bg-white d-flex flex-column align-items-center px-3 py-5 br_15 h-100'
                                        onClick={() => {
                                            handleNav('ovd')
                                        }}>
                                        <div>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="73" height="70" viewBox="0 0 73 70" fill="none">
                                                <g clip-path="url(#clip0_409_423)">
                                                    <path d="M46.0524 8.02509H24.7974V19.3342H46.0524V8.02509Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M22.8126 26.7357H11.7989V38.0448H22.8126V26.7357Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M59.2479 26.7357H48.0372V38.0448H59.2479V26.7357Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M23.214 32.3329H47.4387" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M6.67044 44.6419H27.0547" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M44.0906 44.5436H64.4746" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M35.6295 18.8495V32.1434" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M17.2149 38.7415V45.5364" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M7.66296 44.1577V50.9523" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M26.0779 43.8615V50.6563" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M44.7877 43.4684V50.2633" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M63.5963 43.6644V50.459" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M53.4534 38.7415V45.5364" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M7.60603 61.9741C10.8921 61.9741 13.556 59.3102 13.556 56.0241C13.556 52.738 10.8921 50.0741 7.60603 50.0741C4.31994 50.0741 1.65604 52.738 1.65604 56.0241C1.65604 59.3102 4.31994 61.9741 7.60603 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M26.3159 61.9741C29.602 61.9741 32.2659 59.3102 32.2659 56.0241C32.2659 52.738 29.602 50.0741 26.3159 50.0741C23.0298 50.0741 20.3659 52.738 20.3659 56.0241C20.3659 59.3102 23.0298 61.9741 26.3159 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M44.9277 61.9741C48.2138 61.9741 50.8777 59.3102 50.8777 56.0241C50.8777 52.738 48.2138 50.0741 44.9277 50.0741C41.6416 50.0741 38.9777 52.738 38.9777 56.0241C38.9777 59.3102 41.6416 61.9741 44.9277 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                    <path d="M63.5392 61.9741C66.8253 61.9741 69.4892 59.3102 69.4892 56.0241C69.4892 52.738 66.8253 50.0741 63.5392 50.0741C60.2531 50.0741 57.5892 52.738 57.5892 56.0241C57.5892 59.3102 60.2531 61.9741 63.5392 61.9741Z" stroke="#1A82E2" stroke-width="1.97109" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_409_423">
                                                        <rect width="72" height="69.8182" fill="white" transform="translate(0.5 0.0909424)" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                        </div>
                                        <h2 className='font_16 font_400 mt-3 mb-3'>OVD Classification</h2>
                                        <div className='d-flex justify-content-center flex-wrap gap-1'>
                                        </div>
                                    </div>
                                </div>
                            }


                            {/* <div className='col-12 col-md-6 col-lg-3 mb-4 mb-lg-0'>
                                <div className='cursor-pointer shadow_sm3 bg-white d-flex flex-column align-items-center px-3 py-5 br_15 h-100' 
                                onClick={() => { 
                                    // handleNav('resume')
                                 }}>
                                    <div>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="73" height="90" viewBox="0 0 73 90" fill="none">
                                            <rect x="2" y="1.5" width="69" height="87" rx="14.5" fill="white" stroke="#1A82E2" stroke-width="3" />
                                            <path d="M16.25 16.0715H51.9286" stroke="#1A82E2" stroke-width="3" stroke-linecap="round" />
                                            <path d="M16.25 36.6428H51.9286" stroke="#1A82E2" stroke-width="3" stroke-linecap="round" />
                                            <path d="M16.25 57.2144H51.9286" stroke="#1A82E2" stroke-width="3" stroke-linecap="round" />
                                            <path d="M16.25 77.7856H37.7857" stroke="#1A82E2" stroke-width="3" stroke-linecap="round" />
                                        </svg>
                                    </div>
                                    <h2 className='font_16 font_400 mt-3 mb-3'>Resume Parser</h2>
                                    <div className='d-flex justify-content-center flex-wrap gap-1'>
                                    </div>
                                </div>
                            </div> */}

                                <div className=' col-12 col-md-6 col-lg-3 mb-4 mb-lg-3'>
                                    <div className='cursor-pointer shadow_sm3 bg-white d-flex align-items-center px-3 py-5 br_15 h-100'
                                        onClick={() => {
                                            handleNav('chatbot')
                                        }}>
                                        <div className='m-auto text-center'>
                                            <div>
                                                <i class="far fa-comment-alt fa-4x text_master2"></i>
                                            </div>
                                            <h2 className='font_16 font_400 mt-3 mb-3'>AI Chatbot</h2>
                                        </div>
                                    </div>
                                </div>
                        </div>
                    </div>
                </div>
            </div >
        </>
    )
}
